import { ProfileFormData } from "../types/form";

export const generateVCard = (formData: ProfileFormData): string => {
  const vcard = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `FN:${formData.firstName} ${formData.lastName}`,
    `N:${formData.lastName};${formData.firstName};;;`,
    `PHOTO:${formData.headshot instanceof String ? formData.headshot : ""}`,
    formData.title ? `TITLE:${formData.title}` : "",
    formData.organizationName ? `ORG:${formData.organizationName}` : "",
    formData.email ? `EMAIL:${formData.email}` : "",
    formData.phone ? `TEL:${formData.phone}` : "",
    formData.website ? `URL:${formData.website}` : "",
    formData.address
      ? `ADR:;;${formData.address.streetAddress1 || ""} ${formData.address.streetAddress2 || ""};${formData.address.city || ""};${formData.address.state || ""};${formData.address.zipCode || ""};`
      : "",
    "END:VCARD",
  ]
    .filter((line) => line)
    .join("\n");

  return vcard;
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export const validateImageFile = (
  file: File,
  maxSizeMB: number = 5,
): { isValid: boolean; error?: string } => {
  const validTypes = ["image/jpeg", "image/jpg", "image/png"];
  const maxSizeBytes = maxSizeMB * 1024 * 1024;

  if (!validTypes.includes(file.type)) {
    return {
      isValid: false,
      error: "Please select a valid image file (JPG, PNG)",
    };
  }

  if (file.size > maxSizeBytes) {
    return {
      isValid: false,
      error: `File size must be less than ${maxSizeMB}MB`,
    };
  }

  return { isValid: true };
};

export const generateSharingMetadata = (formData: ProfileFormData): string => {
  return `Meet ${formData.firstName} ${formData.lastName}${formData.title ? `, ${formData.title}` : ""}`;
};

export const extractTopicId = (appLink: string): string | null => {
  const match = appLink.match(/\/topic\/([a-f0-9]+)$/);
  return match ? match[1] : null;
};

export const generateQRCodeUrl = (topicId: string): string => {
  return `https://dev.viiision.com/api/exhibit/qr?id=${topicId}`;
};
